import { siteData } from '@/mocks/siteData';

export default function AppSection() {
  const { app } = siteData;

  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-10 w-64 h-64 rounded-full bg-accent-400 blur-3xl"></div>
            <div className="absolute bottom-10 left-10 w-48 h-48 rounded-full bg-secondary-400 blur-3xl"></div>
          </div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-12 px-6 md:px-12 py-12 md:py-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-background-50/20 text-background-50 rounded-full text-xs font-label mb-4">
                <i className="ri-smartphone-line"></i>移动端入口
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
                {app.title}
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-[500px] mx-auto lg:mx-0 mb-6">
                {app.description}
              </p>

              <ul className="flex flex-wrap items-center justify-center lg:justify-start gap-3 md:gap-4 mb-8">
                {app.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm text-background-50/90">
                    <i className="ri-checkbox-circle-fill text-accent-400"></i>
                    {f}
                  </li>
                ))}
              </ul>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                {app.platforms.map((p) => (
                  <button
                    key={p.name}
                    className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-background-50 text-primary-700 rounded-full text-sm font-label font-semibold hover:bg-background-100 transition-all duration-200 cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className={`${p.icon} text-lg`}></i>
                    {p.name}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex-shrink-0 w-48 md:w-56 lg:w-64">
              <div className="relative">
                <div className="absolute inset-0 bg-accent-400/30 blur-2xl rounded-full"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20entertainment%20gossip%20app%20interface%20with%20dark%20theme%2C%20warm%20crimson%20and%20gold%20accents%2C%20news%20feed%20with%20celebrity%20headlines%2C%20modern%20mobile%20UI%20design%2C%20clean%20minimal%20layout%2C%20product%20photography%20on%20dark%20background&width=512&height=1024&seq=app-phone&orientation=portrait"
                  alt="黑料App移动端界面展示"
                  className="relative w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}